export default {
  env: 'preproduction',
  cookie: 'md-noticejs-sticky-',
  domain: 'mdirector.com',
};



/** WEBPACK FOOTER **
 ** ./src/environments/preproduction.js
 **/